export default {
	service: ["Service", "Event", "Auszahlung", "Einzahlung", "AGB", "Zertifikat", "FAQs", "Benutzerhandbuch", "VIP"],
	sign: {
		title: "Eingeloggt für {0} Tag",
		SignIn: "Einloggen"
	},
	hotMusicAlbum: "Heißes Musikalbum",
	hotMusic: "Heiße Song-Charts",
	popular: "Neu im Spiel",
	rankings: "Beliebte Filme",
	top: "TOP{0}",
	OnchainServices: "Onchain-Dienste",

	Real: {
		title: "Echtzeit",
		list: [
			"Gesamtanzahl der Online-Benutzer",
			"Durchschnittliches Optimierungsvolumen pro Benutzer",
			"Heatmap der Optimierungsbedarfe",
			"Menge der Plattform-Promotion-Optimierungen"
		]
	},
	work: {
		title: "Belohnung für die Auftragsübermittlung",
		SignIn: "Erhalten"
	},
	Profit: {
		Profit: "Gewinn",
		tabs: ["Gewinn", "Bonus", "Konto"],
		TotalBalance: "Gesamtsaldo",
		TotalLuckyBonus: "Gesamter Glücksbonus",
		todayEarnings: "Heutige Einnahmen",
		availableBalance: "Verfügbarer Saldo",
		title: ["Heutige Einnahmen", "Gesamteinnahmen", "Konto"],
		list: ["Bestellgewinne", "Teamgewinne", "Gesamteinnahmen"],
		order: {
			title: "Bestellgewinn",
			commission: "Bestellprovision"
		},
		Analysis: {
			title: "Gewinnanalyse",
			tips: "Sie haben {0} Transaktionen durchgeführt",
			tabs: ["Heutiger Gewinn", "Gesamtgewinn"],
			totalTitle: ["Bestellgewinn", "Check-in-Gewinn", "Teamgewinn", "Bonusgewinn"]
		}
	},
	CustomerService: {
		title: "Kundendienstzentrum",
		consultation: "Kundendienstberatung",
		btn: "Kontaktieren Sie uns",
		noticeTitle: "Systembenachrichtigung"
	},
	addWallet: "Wallet hinzufügen",
	taskProgress: "Täglicher Aufgabenfortschritt",
	currentProgress: "Aktueller Aufgabenfortschritt",
	awardsBulletin: `{0} Benutzer gewinnt {1} {2} Preis in der Aufgabe.`,
	vip: {
		title: "@:vip.title",
		more: "Mehr anzeigen"
	},
	stats: {
		title: "Datenquellen - Dashboard und API",
		subTitle: "Künstlerstatistiken",
		list: ["Metriken", "Künstler mit aktiven sozialen Medien", "Täglich aktualisiert"]
	}
};
